import { get, post } from './http'

//获取简历的基本信息
export const httpResumeBaseInfoGet = params => post('api/OrderResume/GetResumeBase/' + params);

//新增简历基本信息
export const httpResumeBaseInfoAdd = params => post('api/OrderResume/addresume', params);

//基本信息编辑
export const httpResumeBaseInfoEdit = params => post('api/OrderResume/updateresume', params);

//获取简历的求职意向
export const httpResumeJobIntensionGet = params => post('api/OrderResume/getresumedesireddata/' + params);

//保存简历的求职意向
export const httpResumeJobIntensionEditSave = params => post('api/OrderResume/editresumedesiredinfo', params);

/*---工作经历---*/
//获取工作经历信息
export const httpResumeWorkExperienceGet = params => post('api/OrderResume/GetResumeExperience/' + params);

//添加新的工作经历
export const httpResumeWorkExperienceAdd = params => post('api/OrderResume/addresumeExperience', params);

//删除现有工作经历
export const httpResumeWorkExperienceDelete = params => post('api/OrderResume/deleteresumeexperience', params);

//保存现有工作经历的编辑
export const httpResumeWorkExperienceEdit = params => post('api/OrderResume/updateresumeExperience', params);

/*---项目经历---*/
//获取项目经历
export const httpResumeProjectExperienceGet = params => post('api/OrderResume/GetResumeProject/' + params);

//新增项目经历
export const httpResumeProjectExperienceAdd = params => post('api/OrderResume/addresumeproject', params);

//删除项目经历
export const httpResumeProjectExperienceDelete = params => post('api/OrderResume/deleteresumeproject', params);

//编辑项目经历
export const httpResumeProjectExperienceEdit = params => post('api/OrderResume/updateresumeproject', params);

/*---教育背景---*/
//获取教育背景
export const httpResumeEducationalBackgroundGet = params => post('api/OrderResume/GetResumeEducation/' + params);

//新增教育背景
export const httpResumeEducationalBackgroundAdd = params => post('api/OrderResume/addresumeducation', params);

//删除教育背景
export const httpResumeEducationalBackgroundDelete = params => post('api/OrderResume/deleteresumeeducation', params);

//编辑已有教育背景
export const httpResumeEducationalBackgroundEdit = params => post('api/OrderResume/updateresumeducation', params);

/*---个人简介---*/
//获取个人简介信息
export const httpResumeSelfIntroductionGet = params => post('api/OrderResume/getStatements/' + params);

//个人简介编辑
export const httpResumeSelfIntroductionEdit = params => post('api/OrderResume/editstatements', params);

/*---语言能力---*/
//获取语言能力选项列表及熟练度列表
export const httpResumeLanguageOptionsGet = params => get('api/Language/getLanguages');

//获取语言能力信息
export const httpResumeLanguageAbilityGet = params => post('api/OrderResume/GetResumeLanguage/' + params);

//新增语言能力
export const httpResumeLanguageAbilityAdd = params => post('api/OrderResume/addresumelanguage', params);

//删除语言能力
export const httpResumeLanguageAbilityDelete = params => post('api/OrderResume/deleteresumelanguages', params);

//修改语言能力
export const httpResumeLanguageAbilityEdit = params => post('api/OrderResume/updateresumelanguage', params);


// WEBPACK FOOTER //
// ./src/api/resume.js